import React, { Component } from 'react';
import './SubHeader.css';
export default class SubHeader extends Component {
  render() {
    return (
      <div className={`SubHeader ${this.props.className}`}>
        <div className="bg">
          <div className="subHeaderBg" />
          <div className="subHeaderBg" />
        </div>

        <div className="content">{this.props.children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubHeader/SubHeader.js